module.exports = require("skypager-util/lib/properties");


//////////////////
// WEBPACK FOOTER
// external "skypager-util/lib/properties"
// module id = 2
// module chunks = 0